import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import { SmartSummaryData } from '../tool-content.model';

/**
 * Renders a structured smart summary card with key findings and expandable verbatim examples.
 */
@Component({
  selector: 'app-ai-smart-summary',
  imports: [TranslocoModule],
  templateUrl: './ai-smart-summary.component.html',
  styleUrls: ['./ai-smart-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiSmartSummaryComponent {
  readonly data = input.required<SmartSummaryData>();

  protected readonly title = computed(() => this.data().title);
  protected readonly summary = computed(() => this.data().summary);
  protected readonly keyFindings = computed(() => this.data().keyFindings);
  protected readonly verbatimExamples = computed(() => this.data().verbatimExamples);
  protected readonly hasVerbatims = computed(() => this.verbatimExamples().length > 0);

  protected readonly verbatimsExpanded = signal(false);

  protected toggleVerbatims(): void {
    this.verbatimsExpanded.update((v) => !v);
  }

  protected sentimentClass(sentiment?: string): string {
    const s = sentiment?.toLowerCase();
    if (!s) {
      return '';
    }
    switch (s) {
      case 'positive':
        return 'ai-smart-summary__verbatim-sentiment--positive';
      case 'negative':
        return 'ai-smart-summary__verbatim-sentiment--negative';
      case 'neutral':
        return 'ai-smart-summary__verbatim-sentiment--neutral';
      default:
        return 'ai-smart-summary__verbatim-sentiment--mixed';
    }
  }
}
